import { useContext } from 'react';

import { CustomizationStateContext } from './TemplateCustomizationProvider';
import type { CustomizationState } from './customizationState';

export function useCustomizationState(): CustomizationState {
  const state = useContext(CustomizationStateContext);

  if (!state) {
    throw new Error(
      'useCustomizationState must be used within TemplateCustomizationProvider'
    );
  }

  return state;
}
